import { PRODUCTS_COLLECTION } from 'Queries/PRODUCTS_COLLECTION';
import ProductSection from 'Components/Product/ProductSection';
import classNames from 'classnames';
import { getProductBrandLink } from 'utils/productCollectionUtils';
import { useQuery } from '@apollo/client';

export default function RelevantProduct(props) {
    const { className, productBrand } = props
    const { data } = useQuery(PRODUCTS_COLLECTION, {
        variables: {
            brandIn: [productBrand?.slug]
        }
    })

    return (
        <div className={classNames(className)}>
            <ProductSection
                products={data?.products?.edges}
                title="Sản phẩm liên quan"
                itemClassName="md:grid-cols-5 mb-5"
                viewall={{
                    url: getProductBrandLink(productBrand)
                  }}
            />
        </div>
    )
}